import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalActionButton } from '../../../enums/modal-button-action.enum';
import { ModalContent } from '../../../models/modal-content.model';
import { AuthService } from '../../auth/services/auth.service';

@Component({
  selector: 'lns-modal-error',
  templateUrl: './modal-error.component.html',
  styleUrls: ['./modal-error.component.scss']
})
export class ModalErrorComponent implements OnInit, OnDestroy {
  contentSub: Subscription | undefined;
  requestError: string | null = null;
  modalContent: ModalContent = {
    title: 'Error',
    content: '',
    buttons: [
      {
        title: 'OK',
        width: '200',
        action: ModalActionButton.Cancel
      }
    ]
  };
  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    this.contentSub = this.authService.httpReqError.subscribe(content => {
      this.modalContent = { ...this.modalContent, content };
    });
  }

  closeModal(): void {
    this.modalContent = { ...this.modalContent, content: '' };
  }

  ngOnDestroy(): void {
    if (this.contentSub) {
      this.contentSub.unsubscribe();
    }
  }
}
